import { newNotification } from "@kontextwerk/web-sdk/core/overlay/notifications"
import { newApproval } from "@kontextwerk/web-sdk/core/overlay/approvals"
import { deleteScheduleEvent } from "../../../../../../../../api/kehrblatt/schedule-events"
import { showApiErrorNotification } from "../../../_logic/api-error-notifications"

export const deleteEventAction = async ({
  event,
  isDeleting,
  setDeleting,
  onDeleted,
  onremoveOverlay,
  reschedule = false,
  customerCommunicationMode = null,
  requireApproval = true,
  copy = null,
}: {
  event: ScheduleEvent | null
  isDeleting: () => boolean
  setDeleting: (value: boolean) => void
  onDeleted?: (id: string) => Promise<void> | void
  onremoveOverlay?: () => void
  reschedule?: boolean
  customerCommunicationMode?: AppointmentCustomerCommunicationMode | string | null
  requireApproval?: boolean
  copy?: {
    approvalTitle?: string
    approvalDescription?: string
    approvalLabel?: string
    successMessage?: string
    errorFallback?: string
  } | null
}) => {
  if (!event?.id || isDeleting()) return

  const executeDelete = async () => {
    setDeleting(true)
    try {
      await deleteScheduleEvent(event.id, {
        reschedule,
        customerCommunicationMode,
      })
      newNotification({
        class: "success",
        html:
          copy?.successMessage ??
          (reschedule ? "Bisheriger Termin wird ersetzt." : "Termin wurde abgesagt."),
      })
      await onDeleted?.(event.id)
      onremoveOverlay?.()
    } catch (err) {
      console.error("schedule_event_delete_failed", err)
      showApiErrorNotification(err, copy?.errorFallback ?? "Termin konnte nicht abgesagt werden.", {
        includeRequestId: true,
      })
    } finally {
      setDeleting(false)
    }
  }

  if (requireApproval === false) {
    await executeDelete()

    return
  }

  await newApproval({
    title: copy?.approvalTitle ?? "Termin stornieren",
    description: copy?.approvalDescription ?? "Diesen Termin wirklich stornieren?",
    approvalLabel: copy?.approvalLabel ?? "Ja, stornieren",
    declineLabel: "Abbrechen",
    approvalCallback: async () => {
      await executeDelete()
    },
  })
}
